import { Label, Tooltip } from 'client/CommonComponents';
import './ReceivingBranchDetails.scss'
import AssetInformationOrderDetail from "../AssetOrderDetailView/AssetInformation/AssetInformation-Container";
import AssetInformationApproval from "../AssetApproval/LeadrOrder/AssetInformation/AssetInformation-Container";
import { CONSTANTS } from 'client/utils/constants';

const ReceivingBranchDetails = (props: any) => {
    const {
        detailsByIdItem, 
        orderDetails,
        viewtype,
        detailsByIdIndex
    } = props
    return (
        <div className='my-2 transfer-receiving-block'>
        <div className='Transfer-request'>
            <div className="blueLabel pull-left mb-2 mt-0">Receiving Branch</div>
            <div>
                <Label data-attribute="ReceivingBranchDetails_Default_Label">Cost Center</Label>
                <Tooltip content={detailsByIdItem?.recievingCostCenter || '-'} data-attribute="ReceivingBranchDetails_Default_Tooltip">
                    <div className="content" >{detailsByIdItem?.recievingCostCenter || '-'}</div>
                </Tooltip>
            </div>
        </div>
        {detailsByIdItem?.assets?.map((assetOrderByIdItem : any, assetOrderByIdIndex: number) => <>
        <div className="blueLabel">Asset Information</div>
        {
            viewtype === CONSTANTS.ORDERDETAIL_VIEW && <AssetInformationOrderDetail 
            orderDetails = {orderDetails}
            assetOrderByIdIndex = {detailsByIdIndex?.toString() + assetOrderByIdIndex}
            assetOrderByIdItem = {assetOrderByIdItem}
            detailsByIdItem = {detailsByIdItem}
            />                
        }
        {
            viewtype === CONSTANTS.APPROVAL_VIEW && <AssetInformationApproval 
            orderDetails = {orderDetails}
            assetOrderByIdIndex = {detailsByIdIndex?.toString() + assetOrderByIdIndex}
            assetOrderByIdItem = {assetOrderByIdItem}
            detailsByIdItem = {detailsByIdItem}/>
        }
            
            </>
            )}
        </div>
    )
}

export default ReceivingBranchDetails